module.exports = __webpack_public_path__ + "media/svg-new/svg-notificacoes-15bcaf17.svg";